import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteLocationMutation } from "../../services/appln";

export default function DeleteLocation(props: any): any {
  return (
    <DeletePanel
      useIcon={true}
      deleteMutation={useDeleteLocationMutation}
      deleteArgs={{
        bandobastId: props.bandobastId,
        timeslotId: props.timeslotId,
        id: props.id,
      }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteLocationTitle}
      confirmationDialogMsg={strings.deleteLocationConfirmation}
      errorDialogTitle={strings.deleteLocationFailedTitle}
      errorDialogMsg={strings.deleteLocationFailedMsg}
    />
  );
}
